var _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 150,
    viewBox: "0 0 130 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.448,
    height: 45.448,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 64.3591 59.6743)",
    fill: "url(#paint0_linear_102_38)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 45.448,
    height: 45.448,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 64.3591 47.3371)",
    fill: "url(#paint1_linear_102_38)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 45.448,
    height: 45.448,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 64.3591 35)",
    fill: "url(#paint2_linear_102_38)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_38",
    x1: 43.1231,
    y1: 33.924,
    x2: 0.469223,
    y2: 63.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17493A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_38",
    x1: 43.1231,
    y1: 33.924,
    x2: 0.469223,
    y2: 63.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17493A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_38",
    x1: 43.1231,
    y1: 33.924,
    x2: 0.469223,
    y2: 63.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17493A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.df7ca6dfcc1faffcf23bc50d7fa4c9de.svg";
export { ForwardRef as ReactComponent };